import { createAsyncThunk } from "@reduxjs/toolkit";

//Include Both Helper File with needed methods
import {
  getDays as getDaysApi,
  getQuestionTypes as getQuestionTypesApi,
  getDifficultyLevelAPI,
  getUsersByRoleID
} from "../../helpers/fakebackend_helper";

export const getDays = createAsyncThunk("common/getDays", async (thunkAPI) => {
  try {
    const response = await getDaysApi();
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

export const getQuestionTypes = createAsyncThunk("common/getQuestionTypes", async (type, thunkAPI) => {
  try {
    const response = await getQuestionTypesApi(type); 
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

export const getDifficultyLevel = createAsyncThunk("common/getDifficultyLevel", async (level, thunkAPI) => {
  try {
    const response = await getDifficultyLevelAPI(level); 
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

export const fetchUsersByRoleID = createAsyncThunk("common/fetchUsersByRoleID", async (level, thunkAPI) => {
  try {
    const response = await getUsersByRoleID(level); 
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});